module.exports = __webpack_public_path__ + "img/rr.baf544ed.svg";